'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upgradeDataPropsInterface = undefined;

var _react = require('react');

var _products = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/products');

var _upgradeProducts = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/upgradeProducts');

var upgradeDataPropsInterface = exports.upgradeDataPropsInterface = {
  upgradeData: _react.PropTypes.shape({
    product: _react.PropTypes.oneOf(_products.productValues),
    app: _react.PropTypes.string,
    screen: _react.PropTypes.string,
    upgradeProduct: _react.PropTypes.oneOf(_upgradeProducts.upgradeProductValues)
  })
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface.js
// module id = 93
// module chunks = 3 4 5